import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { GetUrl } from "../config/GetUrl";


export const manageCustomerRetailerApi = createApi({
  reducerPath: "manageCustomerRetailerApi",
  baseQuery: fetchBaseQuery({
    baseUrl: GetUrl.API_URL,
  }),
  endpoints: (builder) => ({
    CreateCustomerSellerPost: builder.mutation({
      query: (data) => ({
        url: "/api/v1/Admin/createUser",
        method: "POST",
        body: data,
        headers: {
          authorization: `Bearer ${localStorage.getItem("tokenAdmin")}`,
        },
      }),
    }),
     getCustomers: builder.query({
      query: ({search,limit,page}) => ({
        url: `/api/v1/Admin/getUsers?search=${search}&limit=${limit}&page=${page}`,
        method: "GET",
        headers: {
          authorization: `Bearer ${localStorage.getItem("tokenAdmin")}`,
        },

      }),
    }),
    getCustomerRetailer: builder.query({
      query: (id) => ({
        url: `/api/v1/Admin/getUserDetail/${id}`,
        method: "GET",
        headers: {
          authorization: `Bearer ${localStorage.getItem("tokenAdmin")}`,
        },

      }),
    }),
    EditCustomerSeller: builder.mutation({
      query: ({ id, data }) => ({
        url: `/api/v1/Admin/updateUser/${id}`,
        method: "PUT",
        body: data,
        headers: {
          authorization: `Bearer ${localStorage.getItem("tokenAdmin")}`,
        },
      }),
    }),
    DeleteCustomerSeller: builder.mutation({
      query: (id) => ({
        url: `/api/v1/Admin/deleteUser/${id}`,
        method: "DELETE",
        headers: {
          authorization: `Bearer ${localStorage.getItem("tokenAdmin")}`,
        },
      }),
    }),
    deactivateRetailerAccount: builder.mutation({
      query: (id) => ({
        url: `/admin/retailer-deactivate/${id}`,
        method: "PUT",
        headers: {
          authorization: `Bearer ${localStorage.getItem("tokenAdmin")}`,
        },
      }),
    }),

  }),
});

export const {
  useCreateCustomerSellerPostMutation,
  useGetCustomersQuery,
  useGetCustomerRetailerQuery,
  useEditCustomerSellerMutation,
  useDeleteCustomerSellerMutation,
  useDeactivateRetailerAccountMutation
} = manageCustomerRetailerApi;
